import React, { useEffect, useMemo, useState} from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { ITEM_PER_PAGE, SEARCH_DELAY } from "../../app.config";
import Pagination from "../../component/Pagination";
import SearchAndExport from "../../component/SearchAndExport";
import SubNavbar from "../../layout/SubNavbar";
import { setLoader } from "../../Store/slices/MasterSlice";
import useDebounce from "../hooks/useDebounce";
import * as API from "../../utils/api.service";

import {
  getSubadminListApiCall,
  editSubadminDataApiCall,
} from "../../Store/slices/subadminSlice";
import {
  ExportToCSV,
  ExportToExcel,
  ExportToPdf,
  handleNoDataFound,
  SWIT_DELETE,
  SWIT_DELETE_SUCCESS,
} from "../../utils/common.service";

export default function ManageSubAdmin() {
  let navigate = useNavigate();
  let dispatch = useDispatch();
  const [search, setSearch] = useState("");
  const debounce = useDebounce(search, SEARCH_DELAY);
  const [page, setPage] = useState(1);
  const [fieldSort, setFieldSort] = useState("id desc");
  const [ascSort, setAscSort] = useState(false);
  const [sortColumn, setSortColumn] = useState("id");
  const [isActive, setIsActive] = useState("Inactive");

  

  const handlePageChange = (newPage) => {
    setPage(newPage);
  };

  const handleSortChange = (fieldName, sort) => {
    setFieldSort(`${fieldName} ${sort}`);
    setSortColumn(fieldName);
    setAscSort(sort === "asc");
  };

  const {
    SubadminList: { data: SubadminList },
  } = useSelector((state) => state.subadmin);

  useEffect(() => {
    handleSubadminListAPI();
  }, [page, debounce, fieldSort]);

  const handleSubadminListAPI = () => {
    let submitData = {
      search: debounce,
      page: page,
      fieldSort,
    };
    dispatch(getSubadminListApiCall(submitData));
  };


  const handleStatusChange = async (id, currentStatus) => {
  console.log('currentStatus :', currentStatus);
    dispatch(setLoader(true));
    const newStatus = currentStatus === "Active" ? "Inactive" : "Active";
  
    let submitData = { id, status: newStatus };
  
    try {
      await dispatch(editSubadminDataApiCall(submitData));
      dispatch(getSubadminListApiCall({
        search: debounce,
        page: page,
        fieldSort: fieldSort,
      }));

      SWIT_DELETE_SUCCESS(`Status changed to ${newStatus} successfully`);
    } catch (error) {
      console.error("Error changing status:", error);
    } finally {
      dispatch(setLoader(false));
    }
  };

  const handleDeleteManage = async (id) => {
    SWIT_DELETE(`You won't be able to delete this!`).then(async (result) => {
      if (result?.isConfirmed) {
        dispatch(setLoader(true));
        let submitData = {
          id: id,
          status: "Deleted",
        };
        dispatch(editSubadminDataApiCall(submitData));
        await SWIT_DELETE_SUCCESS(`Sub admin deleted successfully`);
      }
    });
  };


  const companyListData = useMemo(() => {
   // console.log('SubadminList :', SubadminList);
    return SubadminList?.map((item, index) => (
      <tr key={index}>
        <td>{item?.id}</td>
        <td>{item?.name}</td>
        <td>{item?.email}</td>
        <td>{item?.phone}</td>
        <td>
          <div className="form-check form-switch">
            <input
              className="form-check-input"
              type="checkbox"
              id={`is_active_${item.id}`}
              checked={item?.status === "Active"}
              onChange={(e) =>{
                //console.log('e--------------------', e.target.value)
                handleStatusChange(item?.id, item?.status)
              }
              }
            />
          </div>
        </td>
        <td>
          {/* <a
            className="text-reset fs-18 cursor_pointer"
            onClick={() =>
              navigate(`/manage_teacher/view_teacher_details`, {
                state: { clientData: item },
              })
            }
          >
            <i className="ri-eye-line"></i>
          </a> */}
          <a
            className="text-reset fs-18 m-1 cursor_pointer"
            onClick={() =>
              navigate(`/manage_subadmin/edit_subadmin`, {
                state: { clientData: item },
              })
            }
          >
            <i className="ri-edit-line"></i>
          </a>
          <a
            className="text-reset fs-18 cursor_pointer"
            onClick={() => handleDeleteManage(item?.id)}
          >
            <i className="ri-delete-bin-6-line"></i>
          </a>
        </td>
      </tr>
    ));
  }, [SubadminList]);
  


  return (
    <>
      <div className="content">
        <div className="container-fluid">
          <SubNavbar title={`Manage Sub Admin`} header={`Sub Admin`}/>
          {/* <div className="col-sm-6">
            <div className="d-flex justify-content-end">
              <div className="gap-2">
                <button
                  type="button"
                  className="btn btn-soft-primary"
                  onClick={() => navigate(``)}
                >
                  <i className="ri-settings-2-line align-text-bottom me-1 fs-16 lh-1"></i>
                  Add Subadmin
                </button>
              </div>
            </div>
          </div> */}
          <div className="card rounded-3">
            <div className="card-body">
              <div className="rounded-3 mb-3">
                <SearchAndExport
                  searchFieldName={`sub admin`}
                  setSearch={setSearch} buttonName={`Add Sub Admin`} navigatePath={`/manage_subadmin/add_subadmin`} isExport={false}  
                />
              </div>
              <div className="responsive-table-plugin">
                <div className="table-rep-plugin">
                  <div
                    className="table-responsive"
                    data-pattern="priority-columns"
                  >
                    {Object.keys(SubadminList)?.length > 0 ? (
                      <>
                        <table className="table table-centered mb-0 table-hover">
                          <thead>
                            <tr>
                              <th
                                className={`cursor_pointer bi ${
                                  sortColumn === "id"
                                    ? ascSort
                                      ? "bi-caret-up"
                                      : "bi-caret-down"
                                    : ""
                                }`}
                                onClick={() =>
                                  handleSortChange(
                                    "id",
                                    ascSort ? "desc" : "asc"
                                  )
                                }
                              >
                                ID
                              </th>
                              <th
                                className={`cursor_pointer bi ${
                                  sortColumn === "name"
                                    ? ascSort
                                      ? "bi-caret-up"
                                      : "bi-caret-down"
                                    : ""
                                }`}
                                onClick={() =>
                                  handleSortChange(
                                    "name",
                                    ascSort ? "desc" : "asc"
                                  )
                                }
                              >
                                Name
                              </th>
                              <th
                                className={`cursor_pointer bi ${
                                  sortColumn === "email"
                                    ? ascSort
                                      ? "bi-caret-up"
                                      : "bi-caret-down"
                                    : ""
                                }`}
                                onClick={() =>
                                  handleSortChange(
                                    "email",
                                    ascSort ? "desc" : "asc"
                                  )
                                }
                              >
                                Email
                              </th>
                              <th
                                className={`cursor_pointer bi ${
                                  sortColumn === "phone_no"
                                    ? ascSort
                                      ? "bi-caret-up"
                                      : "bi-caret-down"
                                    : ""
                                }`}
                                onClick={() =>
                                  handleSortChange(
                                    "phone_no",
                                    ascSort ? "desc" : "asc"
                                  )
                                }
                              >
                                Phone
                              </th>
                              <th>Status</th>
                              <th>Action</th>
                            </tr>
                          </thead>
                          <tbody>{companyListData}</tbody>
                        </table>
                      </>
                    ) : (
                      <>{handleNoDataFound("Subadmin")}</>
                    )}
                  </div>
                  <Pagination
                    per_page={ITEM_PER_PAGE}
                    pageCount={SubadminList[0]?.total_client}
                    onPageChange={handlePageChange}
                    page={page}
                    lableName={`Subadmin`}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
